import ApiPermisos from "./../../../services/apiPermisos";
// response.response.data.message
// response.isAxiosError
export default {
  namespaced: true,
  state: {
    prueba: {
      id: 1,
    },
    scenarios: {
      data: [],
    },
    scenario: { id: null, sub_scenarios: [] },
    scenarioselected: { id: null, sub_scenarios: [] },
    subScenario: { id: null },
    subScenarioSelected: { id: null },
    loading: false,
    lineDeals: { data: [] },
    loadingLineDeals: false,
    cargos: [],
    cargo: {},
    loadingCargos: false,
    error: null,
    message: null,
    history: {},
  },
  getters: {
    getScenarios: (state) => {
      return state.scenarios;
    },

    getScenario: (state) => {
      return state.scenario;
    },

    getScenarioSelected: (state) => {
      return state.scenarioselected;
    },

    subScenarioRepetido: (state) => (subScenario) => {
      console.log(state.scenario.sub_scenarios, subScenario);
    },
  },
  mutations: {
    setLoading: (state, loading) => {
      state.loading = loading;
    },
    setLoadingLineDeals: (state, loadingLineDeals) => {
      state.loadingLineDeals = loadingLineDeals;
    },

    setLoadingCargos: (state, loadingCargos) => {
      state.loadingCargos = loadingCargos;
    },

    setScenario: (state, scenario) => {
      state.scenario = scenario;
    },

    setSubScenario: (state, subScenario) => {
      state.subScenario = subScenario;
    },

    pushSubScenario: (state, subScenario) => {
      state.scenario.sub_scenarios.push(subScenario);
    },

    pushPosition: (state, subScenario) => {
      state.scenario.sub_scenarios[
        subScenario.indexSubScenario
      ].position_sub_scenario.push(subScenario);
    },

    delSubScenario: (state, indice) => {
      state.scenario.sub_scenarios.splice(indice, 1);
    },

    setScenarioSelected: (state, scenarioSelected) => {
      state.scenarioSelected = scenarioSelected;
    },

    setScenarios: (state, scenarios) => {
      state.scenarios = scenarios;
    },
    setScenarioInfo: (state, scenarios) => {
      state.scenarios = scenarios;
    },
    setLineDeals: (state, lineDeals) => {
      state.lineDeals = lineDeals;
    },

    setCargos: (state, cargos) => {
      state.cargos = cargos;
    },

    setCargo: (state, cargo) => {
      state.cargo = cargo;
    },

    setMessage: (state, message) => {
      state.error = null;
      state.message = message;
    },

    setError: (state, error) => {
      state.message = null;
      state.error = error;
    },
  },
  actions: {
    // Trae los Escenarios
    actSetScenario: async ({ commit }, scenario) => {
      commit("setScenario", scenario);
      return scenario;
    },

    // Trae los Escenarios
    actScenarios: async ({ commit }, page) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getScenario(page);
        if (response.error) {
          commit("setError", response.error);
          return response.error;
        } else {
          commit("setLoading", false);
          commit("setScenarios", response);
        }
        return true;
      } catch (error) {
        commit("setError", error);
        return error;
      }
    },

    //Trae la lista lineas de Negocio
    actLineDeals: async ({ commit }, data) => {
      try {
        commit("setLoadingLineDeals", true);
        ApiPermisos.getLineDeals(data)
          .then((response) => {
            commit("setLoadingLineDeals", false);
            commit("setLineDeals", response);
            if (response.error) {
              commit("setError", response.error);
              return response;
            } else {
              commit("setMessage", response.message);
              return response;
            }
          })
          .catch((response) => {
            commit("setLoadingLineDeals", false);
            commit(
              "setError",
              response.response ? response.response.data.message : null
            );
            return response;
          });
      } catch (error) {
        commit("setLoadingLineDeals", false);
        commit("setError", error);
        return error;
      }
    },

    // Guarda un escenario

    actSaveScenario: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        await ApiPermisos.saveScenario(data)
          .then((response) => {
            response.error
              ? commit("setError", response.message)
              : commit("setMessage", response.message);
            commit("setLoading", false);
            return response;
          })
          .catch((response) => {
            commit("setLoading", false);
            commit("setMessage", "Ocurrió un error guardando el scenario");
            return response;
          });
      } catch (error) {
        commit("setLoading", false);
        commit(
          "setError",
          "Ocurrió un error guardando el scenario. 'store'"
        );
        return error;
      }
    },

    // Actualiza un escenario

    actUpdateScenario: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        await ApiPermisos.uptScenario(data)
          .then((response) => {
            response.error
              ? commit("setError", response.message)
              : commit("setMessage", response.message);
            commit("setLoading", false);
            return response;
          })
          .catch((response) => {
            commit("setLoading", false);
            commit("setMessage", "Ocurrió un error actualizando el scenario");
            return response;
          });
      } catch (error) {
        commit("setLoading", false);
        commit(
          "setError",
          "Ocurrió un error actualizando el scenario. 'store'"
        );
        return error;
      }
    },
    // Elimina un escenario

    actDeleteScenario: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        await ApiPermisos.delScenario(id)
          .then((response) => {
            response.error
              ? commit("setError", response.message)
              : commit("setMessage", response.message);
            commit("setLoading", false);
            return response;
          })
          .catch((response) => {
            commit("setLoading", false);
            commit("setMessage", "Ocurrió un error eliminado el scenario");
            return response;
          });
      } catch (error) {
        commit("setLoading", false);
        commit("setError", "Ocurrió un error eliminado el scenario. 'store'");
        return error;
      }
    },

    // Trae los Escenarios
    actGetCargos: async ({ commit }, data) => {
      try {
        commit("setLoadingCargos", true);
        let response = await ApiPermisos.getCargos(data);
        if (response.error) {
          commit("setError", response.error);
          return response.error;
        } else {
          commit("setLoadingCargos", false);
          commit("setCargos", response.data);
        }
        return true;
      } catch (error) {
        commit("setError", error);
        return error;
      }
    },

    actSetSubEscenarios({ commit }, subScenario) {
      commit("setSubScenario", subScenario);
    },

    actPushSubEscenarios({ commit }, subScenario) {
      commit("pushSubScenario", subScenario);
    },

    actDelSubEscenarios({ commit }, index) {
      commit("delSubScenario", index);
    },

    actSetPostion({ commit }, position) {
      commit("pushPosition", position);
    },

    actSetError({ commit }, error) {
      commit("setError", error);
    },

    // Guarda mensaje de exito

    actSetMessage({ commit }, message) {
      commit("setMessage", message);
    },
  },
};
